import { useCommonDefaultFilterValues } from '../../../common';

export const useDefaultFilterValues = () => {
    const defaultCommonValues = useCommonDefaultFilterValues();

    return defaultCommonValues;
};
